<template>
  <div>
    <div id="swiper">
      <swiper :options="swiperOption" v-if="loopList.length>0">
        <!--可配置开始时间结束时间  服务器时间不在开始结束时间之间则不显示-->
        <swiper-slide
          v-for="(item, index) in loopList"
          :key="index"
          v-if="serverTime > item.startTime && serverTime < item.endTime "
        >
          <img :src="item.img" class="swiperImg" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>
<!--javascript-->
<script>
import 'swiper/dist/css/swiper.min.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
var vm = ''
export default {
  conponents: { swiper, swiperSlide },
  data: function () {
    return {
      swiperOption: {
        // 所有配置均为可选（同Swiper配置）
        paginationClickable: true,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        scrollbar: '.swiper-scrollbar',
        mousewheelControl: true,
        observeParents: true,
        // onTransitionStart(swiper){
        //   console.log(swiper)
        // }
        slidesPerView: 1,
        spaceBetween: 0,
        // slidesPerGroup: 3,
        // grabCursor: true,//鼠标光标
        autoplay: {
          delay: 4000,//毫秒
          stopOnLastSlide: false,
          disableOnInteraction: false,//滑动不会失效
        },
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {//分页器
          el: '.swiper-pagination',
          clickable: false,
        },
        navigation: { //点击前后
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        lazyLoading: true,
        // 点击事件，避免在dom上绑定事件时，loop复制的dom无点击事件
        on: {
          click: function () {
            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
            // console.log(this); // -> Swiper
            // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。
            const realIndex = this.realIndex;
            vm.linkFn(realIndex)
            // console.log(realIndex)
            // console.log(vm.loopList)

          }
        }
      }
    }
  },
  methods: {
    /****链接跳转****/
    linkFn(realIndex) {      console.log(this.loopList);
      if (this.loopList[realIndex].router) {//跳转路由
        this.$router.push(this.loopList[realIndex].router)
      } else {
        if (this.loopList[realIndex].name == 'diamondMallActive') {
          window.location.href = this.loopList[realIndex].link + '?managerId=' + this.$store.state.userMsg.userMsg.managerId + '&token=' + localStorage.getItem('token')
        }
        else {
          window.location.href = this.loopList[realIndex].link
        }
      }
    },
  },
  computed: {
    serverTime() {
      return this.$store.state.userMsg.userMsg.serverTime || new Date().getTime()
    },
    loopList() {
      return this.$store.state.envData[localStorage.env].loop.concat(this.$store.state.envData.common.loop)
    }

  },
  mounted: function () {
  },
  created: function () {
    vm = this
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
#swiper {
  /*height: 30vh;*/
  min-height: 3.97rem;
  width: 100vw;
  max-width: 100vw;
  overflow: hidden;
  .swiper-container {
    min-height: 3.97rem;
  }
  .swiper-slide {
    min-height: 3.97rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .swiperImg {
    height: 100%;
    width: 100%;
    position: absolute;
  }
}

.swiper-pagination-bullet {
  width: 14px !important;
  height: 8px !important;
  display: inline-block;
  border-radius: 4px !important;
  background: #000;
  opacity: 0.2;
}
</style>



// WEBPACK FOOTER //
// src/components/home/swiper.vue